import React from 'react';
import BtnTaratic from '../../components/ui/BtnTaratic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';

const TenantDataDeletionPage: React.FC = () => {
  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8 font-sans flex-1 text-gray-800">
      <div className="max-w-3xl mx-auto p-8 sm:p-12">
        <h1 className="text-3xl font-bold mb-6 text-gray-900 tracking-tight">Solicitud de Eliminación de Datos de Comercio / Clínica</h1>
        
        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <p className="text-lg text-gray-900 font-medium">
              Si eres un comercio o clínica registrado en nuestra plataforma y deseas solicitar la eliminación de tu cuenta, así como de todos los datos asociados a tu negocio y clientes, sigue las siguientes instrucciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">Proceso de gestión manual por operador</h2>
            <p className="mb-4">
              Debido a la naturaleza crítica de los datos de facturación, historiales médicos (si aplica) y la información de tus clientes, el proceso de eliminación es irreversible y se gestiona manualmente por nuestro equipo de soporte técnico y operaciones.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">Pasos para solicitar la eliminación de tu cuenta</h2>
            <ol className="list-decimal pl-6 space-y-3">
              <li>
                <strong>Paso 1:</strong> Envía un correo electrónico a nuestro equipo de soporte a <a href={`mailto:${import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}`} className="text-blue-700 hover:text-blue-800 underline underline-offset-2 font-medium">{import.meta.env.VITE_SUPPORT_EMAIL || 'contacto@taratic.com'}</a>.
              </li>
              <li>
                <strong>Paso 2:</strong> Asegúrate de que el asunto del correo sea exactamente: <br />
                <code className="bg-gray-100 text-blue-700 px-2.5 py-1 rounded-lg text-sm mt-1 inline-block font-mono">Solicitud de Eliminación de Datos de Comercio - Meta/Instagram</code>
              </li>
              <li>
                <strong>Paso 3:</strong> En el cuerpo del mensaje, debes incluir la siguiente información obligatoria para poder verificar tu identidad como administrador de la cuenta:
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Nombre completo del administrador de la cuenta.</li>
                  <li>Correo electrónico asociado a la cuenta de facturación/registro.</li>
                  <li>Nombre comercial de la clínica o empresa.</li>
                  <li>El ID de la página de Facebook o Instagram vinculada a nuestra plataforma.</li>
                </ul>
              </li>
            </ol>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">Procedimiento del Operador</h2>
            <p className="mb-3">
              Una vez recibida la solicitud, un operador de nuestro equipo llevará a cabo el siguiente procedimiento:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Verificará que la solicitud provenga del correo electrónico administrador autorizado.</li>
              <li>Revocará de inmediato todos los tokens de acceso de la API de Graph de Meta, desconectando tu página de Instagram/Facebook.</li>
              <li>Procederá a la purga definitiva de toda la base de datos de pacientes/clientes asociados a tu clínica.</li>
              <li>Eliminará el historial de conversaciones, métricas, bases de conocimiento (RAG) y credenciales almacenadas.</li>
            </ul>
            <p className="mt-4 font-medium text-gray-900">
              Este proceso de purga de datos por parte del operador se completará en un plazo máximo de <strong>30 días naturales</strong>.
            </p>
          </section>
          
          <section>
            <h2 className="text-xl font-semibold mb-3 text-gray-900 tracking-wide">Notificación de Confirmación</h2>
            <p>
              Una vez finalizada la eliminación completa de los datos de tu comercio y de tus clientes en nuestros sistemas, recibirás un <strong>correo electrónico de confirmación final</strong>.
            </p>
          </section>

          <div className="pt-6 mt-8 border-t border-white/10"></div>
        </div>

        {/* CTA B2B Section */}
        <div className="mt-16 bg-taratic-surface/50 border-none rounded-3xl p-8 backdrop-blur-xl shadow-inner-glow shadow-inner-glow-black-md text-center relative overflow-hidden group">
          <div className="relative z-10 flex flex-col items-center">
            <h3 className="text-2xl font-bold text-white mb-3">¿Eres una clínica buscando automatizar su Instagram o WhatsApp?</h3>
            <p className="text-white/90 mb-6 max-w-lg mx-auto">
              Nuestra IA conversa, atiende y gestiona citas de forma automática en los mensajes directos de tu clínica, 24/7.
            </p>
            
            <form className="w-full max-w-md flex flex-col gap-4" onSubmit={(e) => e.preventDefault()}>
              <input 
                type="email" 
                placeholder="Tu correo electrónico de empresa"
                className="w-full bg-black/40 border border-white/20 rounded-xl px-4 py-3 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all duration-300"
              />
              <BtnTaratic color="blue" className="w-full py-3 shadow-lg shadow-blue-500/20" onClick={() => alert('¡Gracias! En breve nos pondremos en contacto contigo.')}>
                <span className="font-semibold text-lg">Solicitar Acceso</span>
                <FontAwesomeIcon icon={faPaperPlane} className="w-4 h-4 ml-2" />
              </BtnTaratic>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TenantDataDeletionPage;
